import { render, staticRenderFns } from "./RegionCascader.vue?vue&type=template&id=680b8e14&"
import script from "./RegionCascader.vue?vue&type=script&lang=ts&"
export * from "./RegionCascader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports